<template>
    <div class="card-detalhes-pedidos-cancelados-liquidados"> 
        <g-tab-menu :items="items">
            
        </g-tab-menu>     
    </div>
</template>

<script>
import PedidosCanceladosLiquidadosFluxo from './PedidosCanceladosLiquidadosFluxo.js';
export default PedidosCanceladosLiquidadosFluxo
</script>

<style scoped>

</style>